import api from '../api';

// Helper function để lấy auth headers
const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

// Super Accountant API functions
export const superAccountantApi = {
  // Tạo financial case mới (cho super_accountant)
  createFinancialCase: async (token, caseData) => {
    try {
      const response = await api.post('/financial-cases/super-accountant', caseData, {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error creating financial case by super_accountant:', error);
      throw error;
    }
  },

  // Lấy danh sách financial cases đã tạo bởi super_accountant
  getMyFinancialCases: async (token, params = {}) => {
    try {
      const response = await api.get('/financial-cases', {
        headers: getAuthHeaders(token),
        params
      });
      return response.data;
    } catch (error) {
      console.error('Error getting my financial cases:', error);
      throw error;
    }
  },

  // Alias để tương thích với SellerFinance: lấy danh sách financial cases
  getFinancialCases: async (token, params = {}) => {
    try {
      const response = await api.get('/financial-cases', {
        headers: getAuthHeaders(token),
        params
      });
      return response.data;
    } catch (error) {
      console.error('Error getting financial cases (super accountant):', error);
      throw error;
    }
  },

  // Lấy thống kê financial cases đã tạo
  getMyStatistics: async (token, params = {}) => {
    try {
      const response = await api.get('/financial-cases/statistics/overview', {
        headers: getAuthHeaders(token),
        params
      });
      return response.data;
    } catch (error) {
      console.error('Error getting my statistics:', error);
      throw error;
    }
  },

  // Alias để tương thích với SellerFinance: lấy thống kê
  getFinancialStatistics: async (token, params = {}) => {
    try {
      const response = await api.get('/financial-cases/statistics/overview', {
        headers: getAuthHeaders(token),
        params
      });
      return response.data;
    } catch (error) {
      console.error('Error getting financial statistics (super accountant):', error);
      throw error;
    }
  },

  // Lấy danh sách accountants để assign
  getAccountants: async (token) => {
    try {
      const response = await api.get('/financial-cases/accountants', {
        headers: getAuthHeaders(token)
      });
      return response.data;
    } catch (error) {
      console.error('Error getting accountants:', error);
      throw error;
    }
  }
};

// Các thao tác chỉnh sửa/xóa để tương thích với component dùng chung
superAccountantApi.updateFinancialCase = async (token, caseId, caseData) => {
  try {
    const response = await api.put(`/financial-cases/${caseId}`, caseData, {
      headers: getAuthHeaders(token)
    });
    return response.data;
  } catch (error) {
    console.error('Error updating financial case (super accountant):', error);
    throw error;
  }
};

superAccountantApi.deleteFinancialCase = async (token, caseId) => {
  try {
    const response = await api.delete(`/financial-cases/${caseId}`, {
      headers: getAuthHeaders(token)
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting financial case (super accountant):', error);
    throw error;
  }
};

superAccountantApi.cancelFinancialCase = async (token, caseId) => {
  try {
    const response = await api.delete(`/financial-cases/${caseId}/cancel`, {
      headers: getAuthHeaders(token)
    });
    return response.data;
  } catch (error) {
    console.error('Error canceling financial case (super accountant):', error);
    throw error;
  }
};

export default superAccountantApi;
